const activityTypes = {
  TYPING: 'TYPING',
  RESET: 'RESET'
};

export default activityTypes;